import { useCallback, useEffect, useState } from 'react';
import {
  clearUnreadErrorReports,
  getUnreadErrorReportStatus,
  useCurrentUser,
} from '../services/s4p';
import { isPublisherTeamUser } from './index';
import { useErrorReporting } from '../../app/RemoteConfig/RemoteConfig';

export const useUnreadErrorReportStatus = () => {
  const [hasUnreadErrorReports, setHasUnreadErrorReports] = useState(false);
  const user = useCurrentUser();
  const isPublisher = isPublisherTeamUser(user.team.organizationUri);
  const featureFlagOn = useErrorReporting();

  const setHasUnreadErrorReportsCallback = useCallback(async () => {
    const response = await getUnreadErrorReportStatus();
    setHasUnreadErrorReports(response);
  }, []);

  useEffect(() => {
    if (featureFlagOn && isPublisher) {
      setHasUnreadErrorReportsCallback();
    }
  }, [featureFlagOn, isPublisher, setHasUnreadErrorReportsCallback]);

  return {
    hasUnreadErrorReports,
    clearUnreadErrorReports: useCallback(async () => {
      if (featureFlagOn && isPublisher) {
        setHasUnreadErrorReports(false);
        await clearUnreadErrorReports();
      }
    }, [featureFlagOn, isPublisher]),
  };
};
